import { render, staticRenderFns } from "./InvoicesDraft.vue?vue&type=template&id=79a643f4&scoped=true"
import script from "./InvoicesDraft.vue?vue&type=script&lang=ts&setup=true"
export * from "./InvoicesDraft.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a643f4",
  null
  
)

export default component.exports